import {Box, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography} from "@mui/material";
import * as React from "react";
import {useEffect} from "react";
import GenericDialog from "../../../components/dialog/generic-dialog.component";
import {translate} from "../../../translate/translate";
import {ErrorComponent} from "../../../components/error/error.component";
import {URLS} from "../../../services/app-urls";
import {toast} from "react-toastify";
import {Category} from "../../../models/basic/category";
import {PoMonitoringService} from "../../../services/po-monitoring-service";
import {AbstractService} from "../../../services/abstract-service";


const AddCategoryComponent = (props: any) => {
    const {
        openDialog,
        handleCloseDialog,
        isDisabled,
        id,
        category,
    } = props;

    const service = new PoMonitoringService();
    const categoryService = new AbstractService<Category>(URLS.CATEGORY);

    const [selectedCategory, setSelectedCategory] = React.useState<number | undefined>(category?.id || undefined);
    const [dataSource, setDataSource] = React.useState<Category[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);

    useEffect(() => {
        setSelectedCategory(category?.id);
        openDialog && search(category?.active);
    }, [category, openDialog]);

    const search = (ativo = true) => {
        const filter = ativo ? {active: true} : {};
        categoryService.readAll(filter).then(response => {
            setDataSource(response.data);
        }).catch((error: any) => {
            ErrorComponent(error);
        });
    }

    const handleSubmit = () => {
        const obj = {category: selectedCategory};
        setLoading(true);
        service.patch(id, obj).then(response => {
            toast.success(translate.t("successfully_updated"));
            setSelectedCategory(undefined);
            handleCloseDialog(true);
        }).catch((error: any) => {
            ErrorComponent(error);
        }).finally(() => {
            setLoading(false);
        });
    };

    return (
       <GenericDialog
          open={openDialog}
          onClose={() => {
              setSelectedCategory(undefined);
              handleCloseDialog();
          }}
          title={"add_category"}
          colorButton={"primary"}
          labelButton={"save"}
          disableConfirm={isDisabled || !selectedCategory || loading}
          loading={loading}
          handleConfirm={handleSubmit}>
           <Box>
               <Box style={{marginTop: '0.5rem'}}>
                   <FormControl>
                       <Typography style={{fontWeight: 'bold', marginBottom: "16px"}}>
                           {translate.t("select_category_po")}
                       </Typography>
                       <Grid container spacing={2}>
                           {(() => {
                               const columnCount = 2;
                               const rowsPerColumn = Math.ceil(dataSource.length / columnCount);
                               const columns = Array.from({ length: columnCount }, (_, columnIndex) =>
                                   dataSource.slice(
                                       columnIndex * rowsPerColumn,
                                       (columnIndex + 1) * rowsPerColumn
                                   )
                               );
                               const maxRows = Math.max(...columns.map((col) => col.length));

                               return Array.from({ length: maxRows }, (_, rowIndex) => (
                                   <>
                                       {columns.map((column, colIndex) => (
                                           <Grid key={`${colIndex}-${rowIndex}`} size={6} sx={{paddingTop: "0px !important"}}>
                                               {column[rowIndex] ? (
                                                   <RadioGroup
                                                       row
                                                       name="category"
                                                       onChange={(event) =>
                                                           setSelectedCategory(Number(event.target.value))
                                                       }
                                                   >
                                                       <FormControlLabel
                                                           checked={selectedCategory === column[rowIndex].id}
                                                           control={<Radio />}
                                                           label={column[rowIndex].name}
                                                           value={column[rowIndex].id}
                                                       />
                                                   </RadioGroup>
                                               ) : null}
                                           </Grid>
                                       ))}
                                   </>
                               ));
                           })()}
                       </Grid>
                   </FormControl>
               </Box>
           </Box>
       </GenericDialog>
    )
}

export default AddCategoryComponent;
